import React from 'react';

const TypingIndicator: React.FC = () => {
  return (
    <span className="inline-flex items-center">
      <span className="typing-dot"></span>
      <span className="typing-dot"></span>
      <span className="typing-dot"></span>
      <style>{`
        .typing-dot {
          display: inline-block;
          width: 3px;
          height: 3px;
          margin: 0 1px;
          border-radius: 50%;
          background-color: #888;
          opacity: 1;
          animation: typingAnimation 1.4s infinite ease-in-out;
        }
        
        .typing-dot:nth-child(1) {
          animation-delay: 0s;
        }
        
        .typing-dot:nth-child(2) {
          animation-delay: 0.2s;
        }
        
        .typing-dot:nth-child(3) {
          animation-delay: 0.4s;
        }
        
        @keyframes typingAnimation {
          0%, 100% {
            transform: translateY(0);
            opacity: 0.7;
          }
          50% {
            transform: translateY(-2px);
            opacity: 1;
          }
        }
      `}</style>
    </span>
  );
};

export default TypingIndicator;
